module.exports = __webpack_public_path__ + "media/img/frontend_application/country/hk-d89e1dde66952b9ee14e7d37c62fb0cb.jpg";